import React from 'react'
import { Link } from 'react-router-dom'

import Button from '@mui/material/Button'

interface LinkCardProps {
  url: string
  children: JSX.Element | Array<JSX.Element>
}

const LinkCard = (props: LinkCardProps): JSX.Element => {
  return (
    <Button
      variant="outlined"
      sx={{
        textTransform: 'none',
        justifyContent: 'flex-start',
      }}
      component={Link}
      target="_blank"
      rel="noopener noreferrer"
      to={props.url}
    >
      {props.children}
    </Button>
  )
}

export default LinkCard
